module.exports = __webpack_public_path__ + "img/32.f10baf30.png";